'use client'

import { IBasicUser, IFormValues } from '@repo/sdk'
import { useEffect, useState } from 'react'
import { ControllerRenderProps } from 'react-hook-form'
import ReactPhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import { cn } from '../lib'

export const PhoneInput = (
  field:
    | ControllerRenderProps<IBasicUser, 'phone'>
    | ControllerRenderProps<IFormValues, 'account.phone'>,
) => {
  const [country, setCountry] = useState<string>('')

  useEffect(() => {
    if (field.value === undefined) return
    if (field.value === null) {
      if (process.env.NEXT_PUBLIC_SOURCE === 'kcharles') setCountry('gb')
    }
  }, [field.value])

  return (
    <ReactPhoneInput
      buttonClass={cn(
        '!border-input !rounded-l-lg !bg-background dark:!text-neutral-300 dark:!border-input',
        'border-transparent peer-focus-visible:!border-r-0 !border-r-transparent dark:!border-r-transparent',
        'dark:hover:!bg-neutral-700',
      )}
      containerClass={cn('!rounded-lg !border-input dark:!bg-background')}
      country={'gb'}
      dropdownClass={cn('!text-neutral-900 !border-input :!bg-background dark:!text-neutral-300')}
      inputClass={cn(
        '!w-full py-2 !h-[40px] !border-input !rounded-lg shadow-none !bg-background dark:!text-neutral-300',
        'focus-visible:!outline focus-visible:!outline-brand !outline-2 dark:focus-visible:!outline-white dark:focus-visible:!ring-2 peer',
      )}
      placeholder="Phone number"
      {...field}
    />
  )
}
